import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import type { OccDateString } from "~/app/api/occ/OccDateString";
import { moxyMapToRecord, type MoxyMapDTO } from "~/common/types/MoxyMapDTO";

function getApiUrl(): string {
  return occUrl("/fcc/graphs");
}

export interface TrainDetailsDTO {
  trainId?: string;
  avgRlt?: number;
  avgPerMonthPcs?: number;
  validFrom?: OccDateString;
  validTo?: OccDateString;
  salesCoverage?: MoxyMapDTO<CoverageType, SalesCoverageMapDTO>;
}

interface SalesCoverageMapDTO {
  entries?: MoxyMapDTO<CoverageUnit, SalesCoverageDTO>;
}

export interface TrainDetailsData extends Omit<TrainDetailsDTO, "salesCoverage"> {
  salesCoverage?: Partial<Record<CoverageType, Partial<Record<CoverageUnit, SalesCoverageDTO>>>>;
}

export type CoverageType = "CUSTOMER_CATALOG" | "FCC_CATALOG_ONLY";
export type CoverageUnit = "EURO" | "PIECES";

export interface SalesCoverageDTO {
  ytdSales?: number;
  orderbook?: number;
  gap?: number;
  plan?: number;
  budget?: number;
}

interface Params {
  fifteenDigit?: string;
  productLine?: string;
  trainId?: string;
}

export async function fetchTrainDetails(data: Params, abortSignal?: AbortSignal): Promise<TrainDetailsData> {
  const params = new URLSearchParams();
  if (data.fifteenDigit) {
    params.set("fifteenDigit", data.fifteenDigit);
  }
  if (data.productLine) {
    params.set("productLine", data.productLine);
  }
  if (data.trainId) {
    params.set("trainId", data.trainId);
  }

  const response = await occFetch(getApiUrl() + "?" + params.toString(), {
    signal: abortSignal,
  });

  if (response.redirected) {
    window.location.reload();
  }

  if (!response.ok) {
    throw new Error("Error fetching search results");
  }

  const dto = (await response.json()) as TrainDetailsDTO;
  const salesCoverage = dto.salesCoverage
    ? Object.fromEntries(dto.salesCoverage.map(({ key, value }) => [key, moxyMapToRecord(value.entries)]))
    : undefined;

  return { ...dto, salesCoverage };
}
